type PageHeaderProp = {
  title: string;
  subtitle: string;
  description?: string;
};
const PageHeader = ({ title, subtitle, description }: PageHeaderProp) => {
  return (
    <>
      <h2 className="my-4">{title}</h2>
      <div className="font-bold" dangerouslySetInnerHTML={{ __html: subtitle }}></div>
      <div className="b-line"></div>
      {description && description !== '' && <p dangerouslySetInnerHTML={{ __html: description }}></p>}
    </>
  );
};

export default PageHeader;
